import { ButtonHTMLAttributes, FC, ReactNode } from 'react';
import { classNames } from 'primereact/utils';

interface TableIconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Icon rendered inside the chip — usually a `<DownloadIcon />` or
   *  `<TrashIcon />` from `@repo/atomic-components`. */
  children: ReactNode;
}

/**
 * 32×32 bordered chip button used for inline table actions (download,
 * delete, etc.). Visual matches the medical-records page's action
 * column: `border-fletchers-gray-110` border, white resting bg,
 * `hover:bg-fletchers-gray-110` wash, rounded.
 *
 * Spreads any additional props (incl. `data-*` attributes, `onClick`,
 * `title`, `aria-label`) onto the underlying `<button>`, so callers
 * can keep the same `data-delete-document-id`-style dispatch their
 * existing handlers expect.
 */
export const TableIconButton: FC<TableIconButtonProps> = ({ children, className, ...rest }) => (
  <button
    type="button"
    {...rest}
    className={classNames(
      'border-fletchers-gray-110 hover:bg-fletchers-gray-110 flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded border bg-white transition-colors',
      className,
    )}
  >
    {children}
  </button>
);
